export const REPORT_MACHINE_NAMES = {
  DAILY_LOG: "daily-log",
  DAILY_LOGS: "daily-logs-report",
  LOCATION_HISTORY: "location-history",
  VEHICLE_MILEAGE_SUMMARY: "vehicle-mileage-summary",
  VEHICLE_MILEAGE: "vehicle-mileage",
  IFTA_MILEAGE: "ifta-mileage",
  ELD_DEVICE_USAGE_FROM_EVENTS: "eld-usage-report",
  TRIP_REPORT_DETAIL: "trip-report-detail",
  TRIP_DETAIL: "trip-detail",
  SAFETY: "safety-report",
  IFTA_MILEAGE_DETAIL: "ifta-mileage-detail",
  IFTA_SUMMARY: "ifta-summary",
  VEHICLE_DISTANCE: "vehicle-distance-report",
  VEHICLE_INACTIVITY: "vehicle-inactivity-report",
  LOCATIONS_HISTORY: "locations-history-report",
  ELD_EVENTS: "eld-events-report",
  DVIR_HISTORY: "dvir-history",
};

export const REPORT_DISPLAY_NAMES = {
  [REPORT_MACHINE_NAMES.DAILY_LOG]: "Daily Log",
  [REPORT_MACHINE_NAMES.DAILY_LOGS]: "Daily Logs",
  [REPORT_MACHINE_NAMES.LOCATION_HISTORY]: "Location History",
  [REPORT_MACHINE_NAMES.VEHICLE_MILEAGE_SUMMARY]: "Vehicle Mileage Summary",
  [REPORT_MACHINE_NAMES.VEHICLE_MILEAGE]: "Vehicle Mileage",
  [REPORT_MACHINE_NAMES.IFTA_MILEAGE]: "IFTA Mileage",
  [REPORT_MACHINE_NAMES.ELD_DEVICE_USAGE_FROM_EVENTS]:
    "ELD Device Usage From Events",
  [REPORT_MACHINE_NAMES.TRIP_REPORT_DETAIL]: "Trip Report Detail",
  [REPORT_MACHINE_NAMES.TRIP_DETAIL]: "Trip Detail",
  [REPORT_MACHINE_NAMES.SAFETY]: "Safety Report",
  [REPORT_MACHINE_NAMES.IFTA_MILEAGE_DETAIL]: "IFTA Mileage Detail",
  [REPORT_MACHINE_NAMES.IFTA_SUMMARY]: "IFTA Summary",
  [REPORT_MACHINE_NAMES.VEHICLE_DISTANCE]: "Vehicle Distance Report",
  [REPORT_MACHINE_NAMES.VEHICLE_INACTIVITY]: "Vehicle Inactivity Report",
  [REPORT_MACHINE_NAMES.LOCATIONS_HISTORY]: "Locations History Report",
  [REPORT_MACHINE_NAMES.ELD_EVENTS]: "ELD Events Report",
  [REPORT_MACHINE_NAMES.DVIR_HISTORY]: "DVIR History Report",
};
